module.exports = __webpack_public_path__ + "static/media/wcp_vis_con.82d74c30.png";